var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#1E1E1E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 23.5V16.8333C18.5 16.6123 18.4122 16.4004 18.2559 16.2441C18.0996 16.0878 17.8877 16 17.6667 16H14.3333C14.1123 16 13.9004 16.0878 13.7441 16.2441C13.5878 16.4004 13.5 16.6123 13.5 16.8333V23.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 14.3332C8.49994 14.0908 8.55278 13.8512 8.65482 13.6313C8.75687 13.4114 8.90566 13.2164 9.09083 13.0599L14.9242 8.06073C15.225 7.80648 15.6061 7.66699 16 7.66699C16.3939 7.66699 16.775 7.80648 17.0758 8.06073L22.9092 13.0599C23.0943 13.2164 23.2431 13.4114 23.3452 13.6313C23.4472 13.8512 23.5001 14.0908 23.5 14.3332V21.8332C23.5 22.2753 23.3244 22.6992 23.0118 23.0117C22.6993 23.3243 22.2754 23.4999 21.8333 23.4999H10.1667C9.72464 23.4999 9.30072 23.3243 8.98816 23.0117C8.67559 22.6992 8.5 22.2753 8.5 21.8332V14.3332Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/home_icon.a6da966f54cc9bd4c10b03470a0adc0d.svg";
export { ForwardRef as ReactComponent };